var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"clearable":"clearable","transfer":"transfer","type":"datetimerange","format":"yyyy-MM-dd HH:mm","placement":"right-end","placeholder":"Select time"},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e7b22b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rcmTableFormItems/DatePicker.vue
// module id = null
// module chunks = 